import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/admin/payment/advertiser' // 광고목록 조회

const fetchKey = (page, maxData, searchWord, searchType) =>
	`${M_KEY}?${page && 'page=' + page}${maxData && '&maxData=' + maxData}${searchWord && '&searchKeyword=' + searchWord}${searchType && '&searchType=' + searchType}`;

export function useAdminPaymentADList(page=1, maxData=1000, searchWord='', searchType='') {
	const { data: token } = useToken();

	const KEY = fetchKey(page, maxData, searchWord, searchType ?? '구분 전체');


	const fetcher = () => fetchAPI(KEY, token, page, maxData);
	const { data, mutate, isLoading } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { adminPaymentADList: data?.list, mutateAdminPaymentADList: mutate, total: data?.total, isLoading };
}

async function fetchAPI(KEY:string, token:any, page: number, maxData: number): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		const list = response.result?.result?.list || [];
		const totalCount = response.result?.result?.totalCount || 0;
		const pageNumber = Number(page) || 1;
		const pageSize = Number(maxData) || list.length || 0;
		const baseIndex = pageSize > 0 ? (pageNumber - 1) * pageSize : 0;
		const mapped = list.map((item, index) => ({
			...item,
			no: baseIndex + index + 1,
		}));
		return {list: mapped, total: totalCount}
	} catch (error) {
		console.error('Failed to fetch Admin Payment AD List:', error);
		return { list: [], total: 0 };
	}
}
